// import logo from './logo.svg';
import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import Login from './login/login';
import LoginRegister from './register/LoginRegister';
import Layout from './sidebar/layout';
// import HomePage from './home/home';
import SubscriptionPlans from './subscription/SubscriptionPlans';
import VerifyBox from './Auth/verify';
import UserHome from './user-home/userhome';
import authService from './Auth/AuthService';
import LoginView from './myprofile/ProfilePage';
import SchoolPage from './pages/SchoolPage';
import StudentPage from './pages/StudentPage';
import CheckoutPage from './subscription/CheckoutPage';
import ReceiptPage from './reciept/ReceiptPage';
import CouponList from './coupon/CouponList';
import AdminHome from './user-home/AdminHome';
import AdminRegister from './register/AdminRegister';
import LoginDetailView from './view-model/LoginDetailView';
import OrderView from './view-model/OrderView';
import ClassRoomPage from './pages/ClassRoomPage';
import FeesStructurePage from './pages/FeesStructurePage';
import PaymentReceipt from './reciept/PaymentReceipt';
import SingleMarksheet from './reciept/MarksheetReceipt';
import AutoLogout from './Auth/AutoLogout';
import StudentIDCards from './marksheet/StudentIDCards';
import MarksheetPage from './pages/MarksheetPage';
import AddSubscriptionPlan from './subscription/AddSubscriptionPlan';
import TransferCertificatePage from './pages/TransferCertificatePage';
import TeacherViewPage from './pages/TeacherViewPage';
import ExcelsheetUploadPage from './pages/ExcelsheetUploadPage';
import EntryCard from './reciept/EntryCard';
// import StudentMarksheetPage from './pages/StudentMarksheetPage'
import HolidayPage from './dashboard/HolidayPage';
import ExperienceCertificatePage from './pages/ExperienceCertificatePage';
import CertificateVerifyPage from './pages/CertificateVerifyPage';
import BulkSalarySlip from './pages/BulkSalarySlip';
import EmpIDCard from './pages/EmpIDCard';
import ScannerPage from './emp-card/ScannerPage';
// import SchoolHome from './home/SchoolHome';
// import AppHome from './others/AppHome';
// import SchoolManagement from './others/SchoolManagement';
import SchoolDashboard from './home/SchoolDashboard';
import BlogPage from './home/BlogPage';
import ImageToPDFConverter from './emp-card/ImageToPDFConverter';
import OfferLetterGenerator from './emp-card/OfferLetterGenerator';
import TermsAndConditions from './home/TermsAndConditions';
import UserOtpPage from './pages/OtpViewPage';
import ShiftPolicyViewPage from './pages/ShiftPolicyViewPage';
import SmsConfigViewPage from './pages/SmsConfigViewPage';
import ContactViewPage from './pages/ContactViewPage';
import PrivacyPolicy from './home/PrivacyPolicy';
import BulkMarksheetPage from './pages/BulkMarksheetPage'
import FeesView from './model/FeesView';
import EmployeeLoginDetails from './view-model/EmployeeLoginDetails';
import SalarySlipView from './view-model/SalarySlipView';
import Home from './components/Home';

import ListQuestionPapers from './components/question/ListQuestionPapers';
import AddQuestionPaper from './components/question/AddQuestionPaper';
import EditQuestionPaper from './components/question/EditQuestionPaper';
import ViewQuestionPaper from './components/question/ViewQuestionPaper';
import TimetableView from './pages/TimetableView';
import FeesManagementPage from './view-model/FeesManagementPage';
import QuestionPaperBuilder from './components/QuestionPaper/QuestionPaperBuilder';

function App() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const token = authService.tokenInfoNew();
    if (token?.is_subscribe < -7 && token?.roles !== "SUPERADMIN")
      authService.logout();
    else
      setUser(token);
    sessionStorage.setItem("hide", true);
    console.log(token);
  }, []);

  return (
    <Router //basename={process.env.PUBLIC_URL}
    >
      <AutoLogout />
      {/* <MenuBar /> Always visible on all pages */}
      {user ? (
        <Layout>
          <Routes>
            {user?.roles === "SUPERADMIN" ? (
              <><Route path="/" element={<AdminHome />} />
                <Route path="/coupon" element={<CouponList />} />
                <Route path="/users-details" element={<LoginDetailView user={user?.roles} />} />
                <Route path="/order-details" element={<OrderView />} />
                <Route path="/subscriptions-plan" element={<AddSubscriptionPlan />} />
                <Route path="/subscriptionplans" element={<SubscriptionPlans />} />
                <Route path='/excel' element={<ExcelsheetUploadPage />} />
                <Route path="/school" element={<SchoolPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/user-otp" element={<UserOtpPage />} />
                <Route path="/contactus" element={<ContactViewPage />} />
                <Route path="/sms-config" element={<SmsConfigViewPage user={user} />} />
                <Route path="/contact/view/:id" element={<ContactViewPage />} />
              </>
            ) : user?.is_verfied === false ? (
              <Route path="/verify" element={<VerifyBox />} />
            ) : (<>
              <Route path="/" element={<UserHome />} />
              <Route path="/register" element={<LoginRegister />} />
              <Route path="/school/:masterId" element={<SchoolPage />} />
              <Route path="/teacher" element={<TeacherViewPage user={user} />} />
              <Route path="/student/:schoolCode" element={<StudentPage user={user} />} />
              <Route path="/loginview" element={<LoginView />} />
              <Route path="/subscriptionplans" element={<SubscriptionPlans />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/receipt" element={<ReceiptPage />} />
              <Route path="/classroom" element={<ClassRoomPage user={user} />} />
              <Route path='/fees-structure' element={<FeesStructurePage masterId={user?.mas_code} />} />
              <Route path="/payment-receipt" element={<PaymentReceipt />} />
              <Route path="/marksheet-receipt" element={<SingleMarksheet masterId={user?.mas_id} />} />
              <Route path="/transfer" element={<TransferCertificatePage user={user} />} />
              <Route path="/idcard" element={<StudentIDCards />} />
              <Route path="/certificate" element={<MarksheetPage user={user} />} />
              <Route path='/excel' element={<ExcelsheetUploadPage user={user} />} />
              <Route path='/entry-card' element={<EntryCard />} />
              <Route path="/bulk-marksheet" element={<BulkMarksheetPage user={user} />} />
              <Route path="/holiday" element={<HolidayPage />} />
              <Route path="/certificate-emp" element={<ExperienceCertificatePage user={user} />} />
              <Route path="/salary-slip-bulk" element={<BulkSalarySlip user={user} />} />
              <Route path="/employee-card" element={<EmpIDCard />} />
              <Route path="/scanner" element={<ScannerPage />} />
              <Route path="/image-pdf" element={<ImageToPDFConverter />} />
              <Route path="/offer-letter" element={<OfferLetterGenerator user={user} />} />
              {/* <Route path="/tc-structure" element={<TCStructurePage user={user} />} /> */}
              <Route path="/shift-policy" element={<ShiftPolicyViewPage user={user} />} />
              <Route path="/sms-config" element={<SmsConfigViewPage user={user} />} />
              <Route path="/fees-view" element={<FeesView user={user} />} />
              <Route path='/employee-login-details' element={<EmployeeLoginDetails />} />
              <Route path='/salary-slip-view' element={<SalarySlipView user={user} />} />
              <Route path='/time-table' element={<TimetableView />} />
              <Route path='/fees-entry-view' element={<FeesManagementPage />} />
              <Route path="/question-papers" element={<QuestionPaperBuilder />} />
              
            </>)}
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path="/" element={<SchoolDashboard />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<LoginRegister />} />
          <Route path="/verify/:code" element={<CertificateVerifyPage />} />
          <Route path="/suports" element={<BlogPage />} />
          <Route path="/image-pdf" element={<ImageToPDFConverter />} />
          <Route path="/offer-letter" element={<OfferLetterGenerator />} />
          {/* <Route path="/result" element={<CheckResultPage />} /> */}
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/church-manage" element={<Home />} />
          {/* <Route path="/about-us" element={<AboutUs />} /> */}


          {/* <Route path="/" element={<Navigate to="/question-papers" />} /> */}
          <Route path="/question-papers" element={<ListQuestionPapers />} />
          <Route path="/question-papers/add" element={<AddQuestionPaper />} />
          <Route path="/question-papers/edit/:id" element={<EditQuestionPaper />} />
          <Route path="/question-papers/view/:id" element={<ViewQuestionPaper />} />
        </Routes>
      )}
    </Router>
  );
}
// const theme = createTheme({
//   palette: {
//     mode: 'light',
//     primary: {
//       main: '#2196F3',
//       light: '#64B5F6',
//       dark: '#1976D2',
//     },
//     secondary: {
//       main: '#FF4081',
//       light: '#FF79B0',
//       dark: '#C60055',
//     },
//     background: {
//       default: '#f8fafc',
//       paper: '#ffffff',
//     },
//     success: {
//       main: '#4CAF50',
//       light: '#80E27E',
//       dark: '#087F23',
//     },
//     error: {
//       main: '#F44336',
//       light: '#FF7961',
//       dark: '#BA000D',
//     },
//     warning: {
//       main: '#FF9800',
//       light: '#FFC947',
//       dark: '#C66900',
//     },
//     info: {
//       main: '#2196F3',
//       light: '#64B5F6',
//       dark: '#1976D2',
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Inter", "Helvetica", "Arial", sans-serif',
//     h1: {
//       fontWeight: 700,
//       fontSize: '2.5rem',
//     },
//     h2: {
//       fontWeight: 600,
//       fontSize: '2rem',
//     },
//     h3: {
//       fontWeight: 600,
//       fontSize: '1.75rem',
//     },
//     h4: {
//       fontWeight: 600,
//       fontSize: '1.5rem',
//     },
//     h5: {
//       fontWeight: 600,
//       fontSize: '1.25rem',
//     },
//     h6: {
//       fontWeight: 600,
//       fontSize: '1rem',
//     },
//     button: {
//       fontWeight: 600,
//       textTransform: 'none',
//     },
//   },
//   shape: {
//     borderRadius: 12,
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
//           border: '1px solid rgba(0,0,0,0.05)',
//           transition: 'all 0.3s ease-in-out',
//           '&:hover': {
//             boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
//             borderColor: 'rgba(0,0,0,0.1)',
//           },
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           fontWeight: 600,
//           textTransform: 'none',
//           padding: '8px 20px',
//         },
//         contained: {
//           boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
//           '&:hover': {
//             boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//           },
//         },
//       },
//     },
//     MuiChip: {
//       styleOverrides: {
//         root: {
//           borderRadius: 6,
//           fontWeight: 500,
//         },
//       },
//     },
//     MuiTableRow: {
//       styleOverrides: {
//         root: {
//           '&:last-child td, &:last-child th': {
//             border: 0,
//           },
//         },
//       },
//     },
//     MuiTableCell: {
//       styleOverrides: {
//         root: {
//           borderBottom: '1px solid rgba(224, 224, 224, 0.5)',
//         },
//         head: {
//           fontWeight: 600,
//           backgroundColor: 'rgba(0, 0, 0, 0.02)',
//         },
//       },
//     },
//   },
// });
export default App;
